import { useEffect } from 'react';

import { finishTracking } from './tracking';
import { type TrackingKey } from './types';

export function PerfTrackingStopper({
  trackingKey,
  condition = true,
}: {
  trackingKey: TrackingKey;
  condition?: boolean;
}) {
  useEffect(() => {
    if (!condition) return;
    const raf = requestAnimationFrame(() => {
      finishTracking({ key: trackingKey });
    });
    return () => cancelAnimationFrame(raf);
  }, [trackingKey, condition]);
  return null;
}
